import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import boyImg from "../../images/blankPicBoy2.png";
import gitlImg from "../../images/blankPic3.png";
import { OnlineMatchContainer } from './OnlineMatchContainer';
import { toast, ToastContainer } from 'react-toastify';
import MessengerModal from '../MessengerModel';
function ProfileContainer({ profileData, unreadCount }) {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const gender = localStorage.getItem('gender');
    const accountType = localStorage.getItem('account_type');
    const navigate = useNavigate();

    localStorage.setItem('username', profileData.username)

    const defaultImage = gender === 'F' ? gitlImg : boyImg;
    const profileImage = profileData && profileData.photo
        ? profileData.photo
        : defaultImage;
    const handleMessengerClick = (event) => {
        event.preventDefault(); // Prevent navigation
        setIsModalOpen(true); // open modal

    };
    return (
        <div className="col-lg-3 col-12">
            <div className='leftNav-Container'>

                <div className="leftNav">
                    <div className="leftUser text-center">
                        <img
                            src={profileImage}
                            alt="user img"
                            className="img-fluid"
                            style={{
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                            }}
                        />

                        <p className="userName">{profileData && profileData.name ? profileData.name : ''} {profileData && profileData.last_name ? profileData.last_name : ''}</p>
                        <p className="userID">ID - {profileData && profileData.username ? profileData.username : ''}</p>
                        <p className="editProfile"><Link to="/view-profile">Edit Profile</Link></p>
                    </div>
                    <div className="leftNavLink text-center">
                        <div className="leftNavLink text-center">
                            <Link to="/my_matches">Matches</Link><br />
                            <Link to="/activity">Activity</Link><br />
                            <Link to="search">Search</Link><br />
                            <a href="#!" onClick={handleMessengerClick}>
                                Messenger{" "}
                                {unreadCount > 0 && (
                                    <span
                                        style={{
                                            backgroundColor: "red",
                                            color: "white",
                                            borderRadius: "50%",
                                            padding: "2px 6px",
                                            fontSize: "12px",
                                            marginLeft: "5px",
                                        }}
                                    >
                                        {unreadCount}
                                    </span>
                                )}
                            </a><br />
                            <Link to="upgrade">Upgrade</Link><br />
                        </div>
                    </div>
                </div>
                {/* <OnlineMatchContainer /> */}
                <MessengerModal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)} // close modal handler
                />
                <ToastContainer />
            </div>
        </div>

    )
}

export default ProfileContainer